import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams, useToast } from "duck";
import { useUpdateCurrentMedicationMutation } from "requests";
import { FormValues } from "../../../../form/duck";

export const useUpdateMedication = (
  _id: number | null,
  fakeId: string | null,
  onSuccess: () => void
) => {
  const [update] = useUpdateCurrentMedicationMutation({ ignoreResults: true });

  const { id: caseId } = useParams();
  const { shouldSync } = useCurrentCase(data => ({
    shouldSync: data.shouldSync
  }));

  const dispatch = useDispatch();

  const toast = useToast();

  return (values: FormValues) => {
    dispatch(
      casesActions.updateCurrentMedication({
        _id: caseId,
        data: { _id, fakeId, ...values } as any
      })
    );

    if (shouldSync && _id) {
      return update({ variables: { input: { _id, ...values } } }).then(() => {
        onSuccess();
        toast({
          status: "success",
          description:
            "Medication patient is currently taking is updated successfully."
        });
      });
    }

    onSuccess();
    toast({
      status: "success",
      description:
        "Medication patient is currently taking is updated successfully."
    });
  };
};
